<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { ADMIN_STATS } from '@/store/types';
import statsApi from '../../../apis/admin/tickets.api';

export default {
  props: {
    month: {
      type: Number,
      default: 0,
    },
    year: {
      type: Number,
      default: 0,
    },
    employer_id: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const store = useStore();
    const query = ref(null);
    query.value = statsApi.usefetchHomeStatsAdminQuery(1, props.month, props.year, props.employer_id);
    if (query.value) {
      store.commit(ADMIN_STATS.SET_HOME_STATS_MONTH_QUERY, query);
    }
    return { query };
  },
};
</script>
